import { Menu, Transition } from "@headlessui/react";
import { FC } from "react";

import FilterButton from "./filter-button";

import { classNames } from "@utils/class-names";

interface Props {
  text: string;
  className?: string;
}

const FilterMenu: FC<Props> = ({ text, className, children }) => (
  <Menu>
    {({ open }) => (
      <div className={classNames("relative max-w-max", open ? "z-40" : "")}>
        <Menu.Button>
          <FilterButton {...{ text, open, disabled: !children }} />
        </Menu.Button>
        <Transition
          show={!!children && open}
          enter="transition duration-200 origin-top ease-out"
          enterFrom="scale-0"
          enterTo="scale-100"
          leave="transition duration-100 origin-top ease-in"
          leaveFrom="scale-100"
          leaveTo="scale-0"
        >
          <Menu.Items
            static
            className={classNames(
              "flex flex-row flex-wrap px-2 py-4 border-2 rounded bg-white absolute",
              Array.isArray(children) && children.length > 2
                ? "max-w-[36rem]"
                : Array.isArray(children) && children.length === 2
                ? "max-w-[24rem]"
                : "max-w-[12rem]",
              className || ""
            )}
          >
            {children}
          </Menu.Items>
        </Transition>
      </div>
    )}
  </Menu>
);

export default FilterMenu;
